{
  "version": 1,
  "asset_id": "91e1248e-9c47-49f5-9898-4fcd0925fbb8",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/91e1248e-9c47-49f5-9898-4fcd0925fbb8/mrdrive-people.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/91e1248e-9c47-49f5-9898-4fcd0925fbb8/mrdrive-people.png",
  "original_filename": "mrdrive-people.png",
  "size": 1798399,
  "content_type": "image/png",
  "created_at": "2026-07-17T00:25:18Z"
}
